import isolate from "@cycle/isolate"

import * as R from "ramda"

import { STATE_KEY, INPUT_CHECK } from "../../../../constant"

import {
  createCheckInfo,
} from "../../../common"
import { InputCheck, ModificationType} from "../../../../interface"

import { view } from "./view"
import { Confirm, Form } from ".."

const INPUT_CHECKS: InputCheck[] = [
  createCheckInfo("zip1", /^\d{3}$/, "半角数字7桁で入力して下さい。", false),
  createCheckInfo("zip2", /^\d{4}$/, "半角数字7桁で入力して下さい。", false),
  createCheckInfo(
    "addr1",
    /./,
    "番地等英数字は半角で入力して下さい。",
    false,
  ),
  INPUT_CHECK["tel"],
  INPUT_CHECK["fax"],
  INPUT_CHECK["mobile"],
]

export default isolate(Form("address", STATE_KEY.AddressForm, view, INPUT_CHECKS))

const getReqParam = ([user, form] : [any, any]) => {
  const type = ModificationType.Home
  const memberId = R.prop("id", user)
  return {
    type, memberId, body: form,
  }
}

export const AddressConfirm = isolate(Confirm(STATE_KEY.AddressForm, view, getReqParam))
